import { ref } from "vue";
import { Popover } from "bootstrap";
import moment from "moment";
export function usePopover() {
  const popoverData = ref({} as any);
  const popoverState = ref(false);
  const popover = ref();
  function formatArgs(res) {
    popoverData.value.id = res.id;
    popoverData.value.eventName = res.title ?? "";
    popoverData.value.user = res.user;
    popoverData.value.site = res.site;
    popoverData.value.form = res.form;
    popoverData.value.startDate = res.startStr;
    popoverData.value.endDate = res.endStr;
    popoverData.value.allDay = res.allDay;
    popoverData.value.notesCount = res.notesCount;
    popoverData.value.conversationCount = res.conversationCount;
  }
  function initBootstrapPopover(el, options) {
    const delay = {};

    // Handle delay options
    if (el.hasAttribute("data-bs-delay-hide")) {
      delay["hide"] = el.getAttribute("data-bs-delay-hide");
    }

    if (el.hasAttribute("data-bs-delay-show")) {
      delay["show"] = el.getAttribute("data-bs-delay-show");
    }

    if (delay) {
      options["delay"] = delay;
    }

    // Handle dismiss option
    if (el.getAttribute("data-bs-dismiss") == "true") {
      options["dismiss"] = true;
    }

    if (options["dismiss"] === true) {
      options["template"] =
        '<div class="popover" role="tooltip"><div class="popover-arrow"></div><span class="popover-dismiss btn btn-icon"><i class="bi bi-x fs-2"></i></span><h3 class="popover-header"></h3><div class="popover-body"></div></div>';
    }

    // Initialize popover
    const popover = new Popover(el, options);

    // Handle dismiss click
    if (options["dismiss"] === true) {
      const dismissHandler = function (e) {
        popover.hide();
      };

      el.addEventListener("shown.bs.popover", function () {
        const dismissEl = document.getElementById(
          el.getAttribute("aria-describedby")
        );
        dismissEl?.addEventListener("click", dismissHandler);
      });

      el.addEventListener("hide.bs.popover", function () {
        const dismissEl = document.getElementById(
          el.getAttribute("aria-describedby")
        );
        dismissEl?.removeEventListener("click", dismissHandler);
      });
    }

    return popover;
  }
  const hidePopovers = () => {
    if (popoverState.value) {
      popover.value.dispose();
      popoverState.value = false;
    }
  };
  const initPopovers = (element) => {
    hidePopovers();
    // Generate popover content
    const startDate = popoverData.value.allDay
      ? moment(popoverData.value.startDate).format("Do MMM, YYYY")
      : moment(popoverData.value.startDate).format("Do MMM, YYYY - h:mm:ss A");
    const endDate = popoverData.value.allDay
      ? moment(popoverData.value.endDate).format("Do MMM, YYYY")
      : moment(popoverData.value.endDate).format("Do MMM, YYYY - h:mm:ss A");
    const popoverHtml =
      // '<div class="fs-7 mb-2"><span class="fw-bold">User:</span>   ' +
      // popoverData.value.user +
      '</div><div class="fs-7 mb-3"><span class="fw-bold"><i class="bi bi-diagram-3 fs-3 me-2"></i></span>   ' +
      popoverData.value.site +
      // '</div><div class="fs-7 mb-3"><span class="fw-bold">Form:</span>   ' +
      // popoverData.value.form +
      '</div><div class="fs-7 mb-3"><span class="fw-bold"><i class="bi bi-alarm fs-4 me-2"></i> Start:</span>   ' +
      startDate +
      '</div><div class="fs-7 mb-3"><span class="fw-bold"><i class="bi bi-alarm fs-4 me-2"></i> End:</span>   ' +
      endDate +
      '</div><div class="fs-7 mb-4"><span class="fw-bold"><i class="bi bi-chat-left-text fs-4 me-2 align-middle"></i> </span>  ' +
      '<span class="badge badge-secondary rounded-3 me-5 position-relative">' +
      popoverData.value.conversationCount +
      '  <span class="bullet bullet-dot bg-success h-7px w-7px position-absolute translate-middle top-0 start-100"></span></span>' +
      '<span class="fw-bold"><i class="bi bi-card-checklist fs-4 me-2 align-middle"></i></span>  ' +
      '<span class="badge badge-secondary rounded-3 position-relative">' +
      popoverData.value.notesCount +
      " </span>";
    ("</div>");

    // Popover options
    const options = {
      container: "body",
      trigger: "manual",
      boundary: "window",
      placement: "top",
      dismiss: true,
      html: true,
      title:
        "<i class='las la-file-alt fs-3 text-black me-2 align-bottom'></i>" +
        `${popoverData.value.form} (<small>${popoverData.value.id}</small>)`,
      content: popoverHtml,
    };

    // Initialize popover
    popover.value = initBootstrapPopover(element, options);

    // Show popover
    popover.value.show();

    // Update popover state
    popoverState.value = true;

    // Open view event modal
  };
  const getClass = (type) => {
    const defaultClass = ["border-secondary"];
    const classMap = {
      OUTSIDE_PERIOD: ["alert-warning"],
      EXPIRED: ["alert-danger"],
      ON_TIME: ["alert-success"],
      SCHEDULED: ["alert-primary"],
    };
    return classMap[type]?.concat(defaultClass) ?? defaultClass;
  };
  return {
    formatArgs,
    popoverData,
    initBootstrapPopover,
    popoverState,
    popover,
    hidePopovers,
    initPopovers,
    getClass,
  };
}

export function useSite() {
  const sites = ref<any>({});
  const form = ref<any>({});
  const isValidEvent = (formId, siteId, userOrRoleId) => {
    if (formId && siteId && userOrRoleId) {
      // userId can be userId or roleId, so need to check for both
      // now check if siteId exists in sites.value
      const siteValue = sites.value.find((site) => site.webId == siteId);
      if (siteValue) {
        // now check if formId exists in siteValue.siteFormsModels
        const formIndex = siteValue.siteFormsModels.findIndex(
          (form) => form.formDefinitionId == formId
        );
        const userSiteValue = siteValue.userSiteModels.find(
          (user) => user.userAccountId == userOrRoleId
        );

        if (
          formIndex > -1 &&
          userSiteValue &&
          userSiteValue.formUserModels.findIndex(
            (form) =>
              form.formDefinitionId == formId && userSiteValue.siteId == siteId
          ) > -1
        ) {
          return true;
        } else {
          // check for role
          if (siteValue.formRoleModels && siteValue.formRoleModels.length > 0) {
            const roleFormIndex = siteValue.formRoleModels.map((formRole) => {
              if (
                (userSiteValue.siteId == siteId &&
                  formRole.formDefinitionId == formId &&
                  formRole.roleId == userSiteValue.roleId) ||
                formRole.roleId == userOrRoleId
              ) {
                const foundObject = siteValue.userSiteModels.find(
                  (obj) => obj.userAccountId == userOrRoleId
                );
                if (foundObject && foundObject.roleId == formRole.roleId) {
                  return true;
                } else {
                  return false;
                }
                //formRole.roleId == userId means we have received roleId in userId param
              } else {
                return false;
              }
            });
            return roleFormIndex.includes(true);
          }
        }
      }
    }
    return false;
  };
  return { form, sites, isValidEvent };
}
